<template>
	<div class="input-wrapper">
		<input
			class="text-input defaultInputBorder"
			id="rest-search-input"
			type="text"
			:placeholder="placeholder"
			v-on:input="$emit('input', $event.target.value)"
			:aria-label="placeholder"
		/>
		<icon-base
			width="25px"
			height="25px"
			class="input-icon"
			:iconName="'Search Restaurants'"
			:id="'searchRestaurants'"
		>
			<icon-search />
		</icon-base>
	</div>
</template>

<script>
import IconBase from "./IconBase.vue";
import IconSearch from "./icons/IconSearch.vue";

export default {
	name: "InputRestaurantSearch",
	components: {
		IconBase,
		IconSearch
	},
	props: {
		placeholder: {
			type: String
		}
	}
};
</script>

<style lang="scss" scoped>
.input-wrapper {
	position: relative;
}

.text-input {
	@include text-input;
	padding: 15px 40px 15px 20px;
}

.input-icon {
	position: absolute;
	right: 10px;
	top: 50%;
	transform: translate(0, -50%);
	color: $tomato;
}

.defaultInputBorder {
	border: 4px solid #fff;
}
</style>